import React, { useContext } from "react";
import { HelpButton } from "./common/HelpButton";
import RenderLogo from "../RenderLogo";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";

export const QuestionnaireStartPageHeader = ({
	textColor,
	background,
	code,
	title,
	preTitle,
	onHelpClick,
	themeCodeOverride,
}) => {
	const { theme } = useContext(DiseaseGroupContext);

	return (
		<div
			className={
				"bg-white flex flex-col gap-2 items-center text-center p-safeAreaTop"
			}
		>
			<div className={"h-16 px-3"}>
				{RenderLogo(
					code,
					themeCodeOverride ? { group: themeCodeOverride } : theme
				)}
			</div>
			<div className={"w-full"}>
				<span
					className={`${background} block w-full h-10 -mb-5 rounded-t-xxl top-shadow`}
				></span>
				<div className="bg-white flex flex-col items-center w-full pt-7 rounded-t-xxl">
					{preTitle ? (
						preTitle && title ? (
							<span className={`text-md sm:text-xl font-bold ${textColor}`}>
								{preTitle}
							</span>
						) : (
							<h1
								className={`px-3 font-bold max-w-panel text-2xl sm:text-3xl ${textColor} font-medium`}
							>
								{preTitle}
							</h1>
						)
					) : null}
					{title ? (
						<h1
							className={`px-3 font-bold max-w-panel text-2xl sm:text-4xl ${textColor} font-medium mt-6 sm:mt-12`}
						>
							{title}
						</h1>
					) : null}
				</div>
			</div>
			{onHelpClick ? (
				<div className={"absolute top-3 right-6 p-safeAreaTop text-black"}>
					<HelpButton onClick={onHelpClick} color="black" />
				</div>
			) : null}
		</div>
	);
};
